/* IFJ Shop — progressive enhancement: scroll-reveal + header scroll state.
   Additive and safe: if it doesn't run, nothing is hidden (reveal targets
   carry data-ifj-reveal in their own markup and the CSS reveals on .ifj-in,
   with a no-JS / reduced-motion fallback that shows them anyway). */
(function () {
  'use strict';
  // Mark that JS is live, as early as possible, so the reveal CSS (scoped to
  // .ifj-js) only hides content when we can guarantee we'll reveal it.
  document.documentElement.classList.add('ifj-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) { for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('ifj-in'); }

  document.addEventListener('DOMContentLoaded', function () {
    var targets = document.querySelectorAll('[data-ifj-reveal]');

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(targets);
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ifj-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      targets.forEach(function (el) { io.observe(el); });
      // Failsafe: anything still hidden after 2.5s gets shown.
      setTimeout(function () { revealAll(document.querySelectorAll('[data-ifj-reveal]:not(.ifj-in)')); }, 2500);
    }

    // Header scroll state (shadow + tighter padding past 40px)
    var header = document.querySelector('.header-section') || document.querySelector('header.header') || document.querySelector('.header');
    if (header) {
      var tick = function () {
        if (window.scrollY > 40) header.classList.add('ifj-scrolled');
        else header.classList.remove('ifj-scrolled');
      };
      tick();
      window.addEventListener('scroll', tick, { passive: true });
    }
  });
})();
